/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum AccountUsageTypes {
  Combined = "Combined",
  FundingDeposits = "Funding Deposits",
  FeeWithdrawals = "Fee Withdrawals"
}
